<template>
  <v-container fluid class="ma-0 pa-0">
    <v-container style="border: 0px red solid">
      <v-flex d-flex child-flex>
        <v-row dense>
          <v-col v-for="stat in stats" :key="stat.key" cols="12" md="4">
            <StatCard :stat="stat" />
          </v-col>
        </v-row>
      </v-flex>
    </v-container>
  </v-container>
  <overlay-loader v-model="loading" />
</template>
<script>
import StatCard from "@/components/StatCard.vue";
import repo from "@/store/repo.js";
import swalFun from "@/plugins/swalFun";
import OverlayLoader from "@/components/common/OverlayLoader.vue";

export default {
  components: {
    StatCard,
    OverlayLoader,
  },
  name: "HomeComponent",
  props: { dir: String },
  data: () => ({
    loading: false,
    // stats: [
    //   { key: "users", value: 4 },
    //   { key: "customers", value: 7 },
    // ],
  }),
  computed: {
    stats() {
      const obj = repo.stats.getAllStats();
      const result = Object.entries(obj).map(([key, value]) => ({
        key,
        value,
      }));
      return result;
    },
  },
  methods: {
    async fetch() {
      this.loading = true;
      const res1 = await repo.stats.fetchAll();
      console.log("res   stats", res1);
      if (res1) {
        //swalFun.success("success");
      } else {
        swalFun.fail("error");
      }
      this.loading = false;
    },
  },
  async mounted() {
    await this.fetch();
  },
};
</script>
